"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrCatalogs = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const fdr_regular_fusion_fdr_catalogs_content_1 = require("@hotelplan/fdr.regular.fusion.fdr-catalogs-content");
const fdr_regular_fusion_fdr_catalogs_modals_1 = require("@hotelplan/fdr.regular.fusion.fdr-catalogs-modals");
const fdr_catalogs_styles_1 = require("./fdr-catalogs.styles");
const fdr_catalogs_utils_1 = require("./fdr-catalogs.utils");
const FdrCatalogs = ({ onSubmit, catalogs, listLoading, orderLoading, isCaptchaEnabled, cardConfig, orderConfig, }) => {
    var _a;
    const [t] = (0, next_i18next_1.useTranslation)('catalogs');
    const [orderSuccess, setOrderSuccess] = (0, react_1.useState)();
    const orderCatalogsApi = (0, react_1.useRef)();
    const modalsApi = (0, react_1.useRef)();
    const handleSubmit = (values, formik) => __awaiter(void 0, void 0, void 0, function* () {
        setOrderSuccess(undefined);
        if (orderCatalogsApi.current && modalsApi.current) {
            try {
                const success = yield onSubmit((0, fdr_catalogs_utils_1.getFdrCatalogOrderInput)(values, orderCatalogsApi.current.catalogToOrderIds), (values === null || values === void 0 ? void 0 : values.subscribe) || false);
                setOrderSuccess(success);
                if (success === true) {
                    orderCatalogsApi.current.track.order();
                }
                modalsApi.current.openResultModal();
                orderCatalogsApi.current.setOrderedCatalogs([]);
                orderCatalogsApi.current.closeOrderModal();
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
            finally {
                formik.resetForm();
            }
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fdr_catalogs_styles_1.CatalogsHeading, null, t('catalogs:insights.heading')),
        react_1.default.createElement(fdr_regular_fusion_fdr_catalogs_content_1.FdrCatalogsContent, { catalogs: catalogs, loading: listLoading, onSubmit: handleSubmit, openErrorModal: (_a = modalsApi === null || modalsApi === void 0 ? void 0 : modalsApi.current) === null || _a === void 0 ? void 0 : _a.openErrorModal, api: orderCatalogsApi, isCaptchaEnabled: isCaptchaEnabled, cardConfig: cardConfig, orderConfig: orderConfig }),
        react_1.default.createElement(fdr_regular_fusion_fdr_catalogs_modals_1.FdrCatalogsModals, { api: modalsApi, orderSuccess: orderSuccess, loading: orderLoading })));
};
exports.FdrCatalogs = FdrCatalogs;
//# sourceMappingURL=fdr-catalogs.js.map